import { api, type RecommendationItem } from '../api';
import { requireFeatureOrRedirect } from '../auth';
import { coverEl, pluralUk, toast, workHref, pluginContentTypes } from '../utils';
import { warmSlugCache } from '../pretty-cache';

function novelHref(item: RecommendationItem, contentTypes: Record<string, 'novel' | 'manga' | 'anime'>): string {
  return workHref(item.pluginId, item.novelPath, contentTypes[item.pluginId], '&from=recommendations');
}

export async function initRecommendations() {
  // Друзі/рекомендації недоступні гостьовому акаунту (право 'social'): його перекидає в Каталог.
  if (!(await requireFeatureOrRedirect('social'))) return;

  const contentTypes = await pluginContentTypes();
  const list = document.getElementById('recommend-list') as HTMLElement;
  const empty = document.getElementById('recommend-empty') as HTMLElement;

  let items: RecommendationItem[] = [];

  function render() {
    list.innerHTML = '';
    if (!items.length) {
      empty.style.display = 'flex';
      list.style.display = 'none';
      return;
    }
    empty.style.display = 'none';
    list.style.display = 'block';

    for (const item of items) {
      const a = document.createElement('a');
      a.className = `row recommend-row${item.read ? ' recommend-read' : ''}`;
      a.href = novelHref(item, contentTypes);

      const cover = coverEl(item.novelName, item.cover, item.novelId);
      cover.classList.add('cover');

      const meta = document.createElement('div');
      meta.className = 'meta';
      const title = document.createElement('p');
      title.className = 'title';
      title.textContent = item.novelName;
      const sub = document.createElement('p');
      sub.className = 'sub';
      sub.textContent = `Від ${item.fromUsername} • ${item.chapterCount} ${pluralUk(item.chapterCount, ['розділ', 'розділи', 'розділів'])}`;
      meta.appendChild(title);
      meta.appendChild(sub);

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'iconbtn trailing-icon recommend-remove-btn';
      removeBtn.setAttribute('aria-label', 'Видалити рекомендацію');
      removeBtn.title = 'Видалити рекомендацію';
      removeBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      removeBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          await api.removeRecommendation(item.id);
          items = items.filter((i) => i.id !== item.id);
          render();
        } catch (err) {
          toast((err as Error).message);
        }
      });

      a.addEventListener('click', () => {
        // Елемент стає сірим одразу (не чекаючи відповіді сервера), але
        // лишається клікабельним — перехід на сторінку твору не блокуємо.
        if (!item.read) {
          item.read = true;
          a.classList.add('recommend-read');
          api.markRecommendationRead(item.id).catch(() => {
            /* не критично — позначка прочитаного не заважає перегляду */
          });
        }
      });

      a.appendChild(cover);
      a.appendChild(meta);
      a.appendChild(removeBtn);
      list.appendChild(a);
    }
  }

  try {
    const res = await api.recommendations();
    items = res.items;
  } catch (err) {
    toast((err as Error).message);
  }
  render();
  warmSlugCache(
    items.map((item) => ({ pluginId: item.pluginId, path: item.novelPath, title: item.novelName })),
    render,
  );
}
